import { Box, Stack, useTheme } from '@mui/material';
import { Children, PropsWithChildren } from 'react';
import { SwiperSlide } from 'swiper/react';

import { PortalTheme } from '../../theme';
import { SwiperWrapper } from './swiper-wrapper.component';
export interface CarouselA11yProps {
  firstSlideMessage: string;
  lastSlideMessage: string;
  prevSlideMessage: string;
  nextSlideMessage: string;
  paginationBulletMessage: (index: string) => string;
}

export interface CarouselProps extends PropsWithChildren {
  a11y: CarouselA11yProps;
  offsetCards?: boolean;
  initialSlide?: number;
  nested?: boolean;
  onActiveIndexChange?: (index: number) => void;
}

export const Carousel = (props: CarouselProps) => {
  const theme = useTheme<PortalTheme>();

  return (
    <>
      <Stack spacing={3}>
        <SwiperWrapper
          swiper={{
            initialSlide: props.initialSlide ?? 0,
            nested: props.nested,
            onActiveIndexChange: ({ activeIndex }) => {
              props.onActiveIndexChange?.(activeIndex);
            },
            a11y: {
              firstSlideMessage: props.a11y.firstSlideMessage,
              lastSlideMessage: props.a11y.lastSlideMessage,
              prevSlideMessage: props.a11y.prevSlideMessage,
              nextSlideMessage: props.a11y.nextSlideMessage,
              // index is injected by Swiper
              paginationBulletMessage:
                props.a11y.paginationBulletMessage('{{index}}'),
            },
          }}
          slotProps={{
            container: {
              sx: {
                // Clip horizontal overflow at the container boundary.
                // The Swiper uses overflow:visible on mobile to allow adjacent
                // card peeks, but without this clips the overflow bleeds into
                // the page layout and makes the entire page horizontally
                // scrollable on iOS when there are multiple slides.
                overflowX: 'hidden',
                '.swiper': {
                  overflow: 'visible',
                  [theme.breakpoints.up('sm')]: {
                    overflow: 'hidden',
                  },
                },
                '& .swiper-pagination': {
                  pb: theme.spacing(3),
                },
              },
            },
          }}
          offsetCards={props.offsetCards}
        >
          {Children.map(props.children, (child) => (
            <SwiperSlide>
              <Box width="320px">{child}</Box>
            </SwiperSlide>
          ))}
        </SwiperWrapper>
      </Stack>
    </>
  );
};
